module.exports = __webpack_public_path__ + "img/jyd_bg_ic.f88a973d.png";